import Embed from 'components/UI/SlateEditor/Elements/Embed/Embed';
import LinkButton from 'components/UI/SlateEditor/Elements/Link/LinkButton';
import { useEffect, useState } from 'react';
import { useSlate } from 'slate-react';
import HtmlContextMenu from '../Elements/CodeToText/HtmlContextMenu';
import ColorPicker from '../Elements/Color Picker/ColorPicker';
import TableSelector from '../Elements/Table/TableSelector';
import TableContextMenu from '../Elements/TableContextMenu/TableContextMenu';
import Button from '../common/Button';
import Icon from '../common/Icon';
import { activeMark, addMarkData, isBlockActive, isMarkActive, toggleBlock, toggleMark } from '../utils/SlateUtilityFunctions.js';
import useFormat from '../utils/customHooks/useFormat.js';
import './styles.css';
import defaultToolbarGroups from './toolbarGroups.js';

const Toolbar = (props) => {
  const { handleCodeToText } = props;
  const editor = useSlate();
  const isTable = useFormat(editor, 'table');
  const [toolbarGroups, setToolbarGroups] = useState(defaultToolbarGroups);

  // console.log(editor);

  useEffect(() => {
    // Filter out the groups which are not allowed to be inserted when a table is in focus.
    let filteredGroups = [...defaultToolbarGroups];
    if (isTable) {
      filteredGroups = toolbarGroups.map((grp) =>
        grp.filter(
          (element) =>
            //groups that are not supported inside the table
            !['codeToText'].includes(element.type)
        )
      );
      filteredGroups = filteredGroups.filter((elem) => elem.length);
    }
    setToolbarGroups(filteredGroups);
  }, [isTable]);

  const buttonsClassNames = 'inline-flex items-center justify-center p-1 border rounded-xl w-fit border-t-border-color-base bg-t-bg-color hover:border-t-primary-color';

  const BlockButton = ({ format }) => {
    return (
      <div className={`${buttonsClassNames} hover:border-t-primary-color `}>
        <Button
          active={isBlockActive(editor, format)}
          format={format}
          onMouseDown={(e) => {
            e.preventDefault();
            toggleBlock(editor, format);
          }}>
          <Icon icon={format} />
        </Button>
      </div>
    );
  };
  const MarkButton = ({ format }) => {
    return (
      <div className={buttonsClassNames}>
        <Button
          active={isMarkActive(editor, format)}
          format={format}
          onMouseDown={(e) => {
            e.preventDefault();
            toggleMark(editor, format);
          }}>
          <Icon icon={format} />
        </Button>
      </div>
    );
  };
  const Dropdown = ({ format, options }) => {
    return (
      <select className={`${buttonsClassNames} outline-none bg-t-layer-bg-color px-2`} value={activeMark(editor, format)} onChange={(e) => changeMarkData(e, format)}>
        {options.map((item, index) => (
          <option key={index} value={item.value}>
            {item.text}
          </option>
        ))}
      </select>
    );
  };
  const changeMarkData = (event, format) => {
    event.preventDefault();
    const value = event.target.value;
    addMarkData(editor, { format, value });
  };

  return (
    <div className='sticky top-0 flex flex-wrap items-center justify-center gap-4 p-4'>
      {toolbarGroups.map((group, index) => (
        <span key={index} className='toolbar-grp'>
          {group.map((element) => {
            switch (element.type) {
              case 'block':
                return <BlockButton key={element.id} {...element} />;
              case 'mark':
                return <MarkButton key={element.id} {...element} />;
              case 'dropdown':
                return <Dropdown key={element.id} {...element} />;
              case 'link':
                return <LinkButton key={element.id} active={isBlockActive(editor, 'link')} editor={editor} />;
              case 'embed':
                return <Embed key={element.id} format={element.format} editor={editor} />;
              case 'color-picker':
                return <ColorPicker key={element.id} activeMark={activeMark} format={element.format} editor={editor} />;
              case 'table':
                return <TableSelector key={element.id} editor={editor} />;
              // case 'id':
              //   return <Id editor={editor} key={element.id} />;
              // case 'equation':
              //   return <EquationButton editor={editor} key={element.id} />;
              // case 'codeToText':
              //   return <CodeToTextButton handleButtonClick={handleCodeToText} key={element.id} />;
              default:
                return null;
            }
          })}
        </span>
      ))}
      <TableContextMenu editor={editor} />
      <HtmlContextMenu editor={editor} handleCodeToText={handleCodeToText} />
    </div>
  );
};

export default Toolbar;
